
import { defineComponent, ref } from 'vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import Icon from '@/components/icon/Icon';
import IconComponent from '@/components/icon/IconComponent.vue';

export default defineComponent({
  components: {
    ButtonComponent,
    IconComponent
  },
  props: {
    error: {
      type: String
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  setup(_, { emit }) {
    const name = ref();
    const email = ref();
    const password = ref();
    const passwordConfirm = ref();

    function signUp() {
      emit('signup', {
        name: name.value,
        email: email.value,
        password: password.value,
        passwordConfirm: passwordConfirm.value
      });
    }

    return {
      email,
      Icon,
      name,
      password,
      passwordConfirm,
      signUp
    };
  }
});
